import { PureComponent, Fragment } from "react";
import "../../../styles/NavbarCopy.scss";
import ReactNotification from "react-notifications-component";
import navimg from "../../../images/logo.svg";
import * as React from "react";
import _ from "lodash";
import SideNav from "../forms/Sidebar";
import { subDirectory } from "../../../config.json";
// import SideNav from "../forms/Sidebar";
import {
  getLocalStorageValues,
  localstore,
} from "../../../services/authService";
import { FaUser, FaSignInAlt } from "react-icons/fa";
import { IoMdLogIn } from "react-icons/io";
import LoginModal from "../../boat/Modals/LoginModal";
import { MdOutlineArrowOutward } from "react-icons/md";
class NavBar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loggedIn: false,
      showLoginModal: false,
      loading: false,
    };
  }
  setFormApi = (formApi) => {
    this.formApi = formApi;
  };
  HomeLogin = async() => {
    // var postMsg = {"login": "user"}; // this is just example
    // this.postCrossDomainMessage(postMsg);
  }

    //  postCrossDomainMessage = async (msg) =>  {
    //   console.log("ddd",msg)
    //   var win = document.getElementById('ifr').contentWindow;
    //   console.log("win",win)
    //   win.postMessage(msg, "http://ttdc.in/");
    // }
  
  
  
  componentDidMount = async () => {
    console.log("rendering navbar", this.props);
    let UserId = getLocalStorageValues("UserId");
    const UserName = getLocalStorageValues("UserName");
    console.log("d")
    if (!UserId) {
      console.log("UserId");
      await this.setState({
        loggedIn: false,
      });
      console.log(this.state.UserName);
    } else {
      await this.setState({
        loggedIn: true,
        UserName,
      });
    }
  };
  logout = async () => {
    let UserId = "";
    return await this.localstore(UserId);
  };
  localstore = async (key, UserId) => {
    await localstore(key, UserId);
    // this.props.history.push({
    //     pathName:"/home"
    // }
    // )
    // await this.redirect();
  };
  handleLoginClose = async () => {
    await this.setState({ showLoginModal: false, loading: true });
    await this.setState({ loading: false });
  };
  signmodal = async () => {
    await this.setState({ showLoginModal: true })
  }
  loginUsers = async (values) => {
    let UserId = await getLocalStorageValues("UserId");
    let MobileNo = await getLocalStorageValues("MobileNo");
    let EmailId = await getLocalStorageValues("EmailId");
    let UserName =await getLocalStorageValues("UserName");
    await this.setState({ MobileNo, EmailId, UserId, UserName,isUser: true,loggedIn:true });
   
    // await this.setFormValues();
  };
  render() {
    const { loggedIn,showLoginModal } = this.state;
    console.log(this.state)
    return (
      <Fragment>
        <ReactNotification ref={this.notificationDOMRef} />
        {/* <div class="navBar"> */}
        <nav class="navbar sticky-top navbar-expand-lg navbar-light" 
        style={{backgroundColor:"#ffffffc4"}}
        >


          


          <a class="navbar-brand" href="#">
            <img
              width="280px"
              height="50px"
              src={navimg} 
              alt="ttdc-logo"
            />
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            // aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item"> 
                <a class="nav-link navtxt"
                 href="https://ttdc.in/"
                //  ?UserId=50020&UserName=Ram"
                 >
                  Home
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link navtxt"
                  href={`${subDirectory}/boat`}
                >
                  Boating
                </a>
              </li>
              {/* <li class="nav-item">
                <a
                  class="nav-link"
                  href="/pages/TourPackages/TourPackageDetails.html"
                >
                  Tourism
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href={`${subDirectory}/hotel`}>
                  Hotels
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="/Public/OtherService/OtherService.aspx"
                >
                  Other Services
                </a>
              </li> */}
              {console.log(this.state.UserName)}
              { getLocalStorageValues("UserName")||this.state.UserName ? (
                  <li class="nav-item" id="loginoutplacer">
                  <div class="nav-link navtxt signinddiv">
                    {/* <a class="nav-link navtxt" href={`${subDirectory}/auth/login`}> */}
                    <FaUser className="mr-2" />
                    <span>  {getLocalStorageValues("UserName") || this.state.UserName}
                     </span>
                  </div>
                  {/* </a> */}
                </li>
                  ):""}
                {/* // <li>
                //   <a
                //     class="nav-link navtxt signinddiv"
                //   // href="/Public/OtherService/OtherService.aspx"
                //   >
                //     <FaUser className="mr-2" />
                //     {getLocalStorageValues("UserName") || this.state.UserName}
                //   </a>
                // </li> */}
            
              {/* <li class="nav-item" id="loginoutplacer">
                {loggedIn === true ? (
                  <a
                    class="nav-link"
                    onClick={this.logout}
                    href={`${subDirectory}/`}
                  >
                    <i class="fa fa-sign-in"></i>Logout{" "}
                  </a>
                ) : (
                  <a class="nav-link" href={`${subDirectory}/auth/login`}>
                    <i class="fa fa-sign-out text-light" aria-hidden="true"></i>
                    Login
                  </a>
                )}
              </li> */}
              {loggedIn === false && (
                <li class="nav-item" id="loginoutplacer">
                  <div class="nav-link navtxt signinddiv" onClick={this.signmodal}>
                    {/* <a class="nav-link navtxt" href={`${subDirectory}/auth/login`}> */}
 
                      
                    <div> Sign In <MdOutlineArrowOutward className='arr-1'/>  </div>

 
                                 

                  </div>
                  {/* </a> */}
                </li>
              )}
              {loggedIn === true && (
                <span class="nav-item" id="sideNavMenu">
                  <SideNav {...this.props} />
                </span>
              )}
            </ul>
          </div>
        </nav>
        {/* </div> */}
        <LoginModal
          visible={showLoginModal}
          hideFooter={true}
          onSubmit={this.loginUsers}
          showHeader={true}
          handleClose={() => {
            this.handleLoginClose();

          }}
        />
      </Fragment>
    );
  }
}
export default NavBar;



{/* <FaSignInAlt /> */ }